import IconClassCode from 'approot/shared/icons/icon-class-code';
import IconEmailPurple from 'approot/shared/icons/icon-email-purple';
import IconQRCode from 'approot/shared/icons/icon-qr-code';
import IconGoogle from 'approot/shared/icons/icon-google';
import IconNSWDoE from 'approot/shared/icons/icon-nsw-doe';
import IconNTDet from 'approot/shared/icons/icon-nt-det';
import IconSADet from 'approot/shared/icons/icon-sa-det';
import IconCENet from 'approot/shared/icons/icon-cenet';
import * as Styled from './signin-type.style';

export const SigninTypeClassCode = () => (
  <Styled.SigninType>
    <IconClassCode width={24} height={24} />
  </Styled.SigninType>
);

export const SigninTypeEmail = () => (
  <Styled.SigninType>
    <IconEmailPurple width={24} height={24} />
  </Styled.SigninType>
);

export const SigninTypeQrCode = () => (
  <Styled.SigninType>
    <IconQRCode width={24} height={24} />
  </Styled.SigninType>
);

export const SigninTypeGoogle = () => (
  <Styled.SigninType>
    <IconGoogle width={24} height={24} />
  </Styled.SigninType>
);

export const SigninTypeNSWDoe = () => (
  <Styled.SigninType>
    <IconNSWDoE width={24} height={24} />
  </Styled.SigninType>
);

export const SigninTypeNTDET = () => (
  <Styled.SigninType>
    <IconNTDet width={24} height={24} />
  </Styled.SigninType>
);

export const SigninTypeSADet = () => (
  <Styled.SigninType>
    <IconSADet width={24} height={24} />
  </Styled.SigninType>
);

export const SigninTypeCEnet = () => (
  <Styled.SigninType>
    <IconCENet width={24} height={24} />
  </Styled.SigninType>
);
